'use client';

import { type FC, useState } from 'react';

import type { Ingredient } from '@hyex/dxp/types/store/Product/Ingredient';
import DotsCarousel from '@hyex/modules/shared/Carousels/DotsCarousel';
import useIsMobile from '@hyex/utils/hooks/useIsMobile';
import Image from 'next/image';
import ProductIngredient from '../item';
import Modal, { useModalDialog } from '@hyex/ui/Modal';
import TextWithLineBreaks from '@hyex/modules/shared/Inputs/Text';
import parse from 'html-react-parser';

type PropType = {
  ingredients: Ingredient[];
  productName: string;
};

const ProductKeyIngredients: FC<PropType> = ({ ingredients, productName }) => {
  const isMobile = useIsMobile(800);

  const modalDialog = useModalDialog();

  const [isActivate, setActive] = useState(false);

  const [selectedIngredient, setSelectedIngredient] = useState<Ingredient>(null);

  const handleActivate = (ingredient: Ingredient) => {
    setSelectedIngredient(ingredient);

    if (!isActivate) {
      setActive(true);
    } else {
      setActive(false);
    }

    modalDialog.open();
  };

  const modal = (ingredient: Ingredient) => {
    return (
      <>
        {isActivate && (
          <Modal
            {...modalDialog}
            onClose={() => {
              setActive(false);
            }}
          >
            <div className="ingredient-modal">
              <div className="ingredient-title-wrapper">
                <div className="ingredient-img-wrapper">
                  {ingredient?.image && (
                    <Image
                      alt={`Ingredient ${ingredient.name} in ${productName}`}
                      width={90}
                      height={90}
                      src={ingredient.image}
                      quality="70"
                    />
                  )}
                </div>
                <div>
                  <h2>{TextWithLineBreaks(ingredient.name)}</h2>

                  <p>
                    {ingredient.amountPerServing}
                    {ingredient.unitOfMeasure}
                  </p>
                </div>
              </div>
              <div className="ingredient-text-wrapper">{parse(ingredient.fullDescription)}</div>
            </div>
          </Modal>
        )}
      </>
    );
  };

  const keyIngredientsMobile = ingredients.map((ingredient, i) => (
    <>
      <div className="embla-slide" key={i}>
        <ProductIngredient
          ingredient={ingredient}
          onShowModal={() => handleActivate(ingredient)}
          productName={productName}
        />
      </div>
    </>
  ));

  const keyIngredientsDesktop = () => {
    return ingredients.map((ingredient, i) => (
      <ProductIngredient
        key={i}
        onShowModal={() => handleActivate(ingredient)}
        ingredient={ingredient}
        productName={productName}
      />
    ));
  };

  return (
    
    <div>
      <section className="product-key-ingredients" id="ingr">
      <div className="container">
        <h2>Key Ingredients</h2>
        {isMobile ? (
          <div className="ingredient-wrapper">
            <DotsCarousel
              slides={keyIngredientsMobile}
              parentClassName="ingredients-list"
              options={{
                containScroll: 'trimSnaps',
                dragFree: true,
                breakpoints: {
                  '(max-width: 600px)': { align: 'center' },
                },
              }}
            />
          </div>
        ) : (
          <>
            <div className="ingredient-wrapper">{keyIngredientsDesktop()}</div>
          </>
        )}

        {isActivate && modal(selectedIngredient)}
      </div>
    </section></div>
  );
};

export default ProductKeyIngredients;
